import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  Container,
  Spinner,
} from "reactstrap";
import { AvField, AvForm} from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import preloader from "../../../helpers/preloader";
import { checkOutOfStock } from "../../../helpers/po_helper";
import { convertToLowestUnit, GetUpdatedDelivered, formatUnitsForReport } from "../../../helpers/units";
import { useRef } from "react";
import moment from "moment";
import EnterQuantityModal from "../../../components/EnterQuantityModal";
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import calculatePrice from "../../../helpers/calculate_price";

const formatExpiryDate = (expiry_date) => {
  if (!expiry_date) return "N/A";
  const parsed = moment(expiry_date);
  return parsed.isValid() ? parsed.format("M/D/YYYY") : "N/A";
};

const BranchItemsReturn = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const [remarks, setRemarks] = useState('');
  const storeId = localStorage.getItem("store_id")

  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState("")

  useEffect(()=>{
loadAllItems()
  },[])

  useEffect(() => {
    if (selectedItem) {
      loadAllBranchItemBatches();
    }
  }, [selectedItem]);


  const [allItems, setAllItems] = useState([]);
  const loadAllItems = async () => {
   try {
    preloader(true)
    let url = process.env.REACT_APP_BASEURL + "branchitems/getforbranch";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      preloader(false)
      setAllItems(response.data);
    } else {
      preloader(false)
      showNotification(response.message, "Error");
    }
   } catch (error) {
    preloader(false)
    showNotification(error.message, "Error");
   }
  };
  const refSelectedBatch = useRef(null);
  const [allBatches, setAllBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState();
  const loadAllBranchItemBatches = async () => {
    // let url = process.env.REACT_APP_BASEURL + "branchiteminventories/get_by_item_id";
    let url = process.env.REACT_APP_BASEURL + "itemreturns/get_batches_for_return";
    let response = await postSubmitForm(url, {
      item_id: selectedItem.item_id,
      inventory_type:"Kitchen"
    });
    if (response.status === 1) {
      // const result = response.data.filter((store)=>store.store_name === storeName)
      const result = response.data
      const batchOptions = result.map(batch => ({
        ...batch,
        label: `${batch.batch} - Expiry: ${formatExpiryDate(batch.expiry_date)}${batch?.supplier_details?.name ? " - " + batch.supplier_details.name : ""}`,
        value: batch._id
      }));

      setAllBatches(batchOptions);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleDeleteRow = (batch) => {
    setCartItems((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter((item) => item.batch !== batch);
      return updatedCartItems;
    });
  };

// console.log(selectedItem,"Si");
// console.log(selectedBatch,"Sb");
// console.log(cartItems,"CI");
  const handleCheckboxChange = (row, isChecked) => {
    setCartItems(prevCartItems =>
      prevCartItems.map((item) =>
        item.batch === row.batch
          ? { ...item, return_to_supplier: isChecked }
          : item
      )
    );
  };

  const columns_cartitems = [
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "2%" };
      },
    },
    {
      dataField: "category",
      text: props.t("Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "name",
      text: props.t("Name"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    {
      dataField: "batch",
      text: props.t("Batch"),
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
    },
    {
      dataField: "supplier_details.name",
      text: props.t("Supplier"),
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "expiry_date",
      text: props.t("Expiry Date"),
      formatter: (cell, row) => {
               return row.expiry_date ? moment(row.expiry_date).format("DD/MM/YYYY") : '';

      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Return Quantity"),
      dataField: "quantity",
      sort: false,
      formatter: (cell, row) => {
        return (
          <>
            {formatUnitsForReport(row.quantity)}
          </>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },

    },
    {
      dataField: "",
      text: "Return Supplier ?",
      formatter: (cell, row) => {
        return row.supplier_details ? (
          <span className="d-flex justify-content-center">
          <input
            type="checkbox"
            checked={row.return_to_supplier || false}
            onChange={(e) => handleCheckboxChange(row, e.target.checked)}
          />
          </span>
        ) : null;
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      dataField: "",
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDeleteRow(row.batch)
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      sort: false,
    },
  ];


  const handleAddUnits = async (quantity) => {
    var new_array_items = JSON.parse(JSON.stringify(cartItems));
    const existing_item = new_array_items.filter(function (item) {
      return item.batch === selectedBatch.batch;
    });

    if (existing_item.length > 0) {
      showNotification(
        props.t("This item batch is already added."),
        props.t("Error")
      );
    } else if (selectedBatch) {
      let totalEntered = convertToLowestUnit(selectedItem?.unit_levels, quantity);
      let totalAvailable = convertToLowestUnit(selectedItem?.unit_levels, selectedBatch.quantity)
      if (totalEntered > totalAvailable) {
        showNotification("Can not enter more than available in batch", "Warning");
        return
      }
      let convertedQuantity = GetUpdatedDelivered(quantity, selectedItem?.unit_levels)
      let item_to_add = {};
      item_to_add.item_id = selectedItem?.item_id;
      item_to_add.batch = selectedBatch.batch;
      item_to_add.is_free = selectedBatch?.is_free;
      item_to_add.return_to_supplier = false;
      item_to_add.name = selectedItem?.name;
      item_to_add.category = selectedItem?.category;
      item_to_add.sub_category = selectedItem?.sub_category;
      item_to_add.brand = selectedItem?.brand;
      item_to_add.supplier_details = selectedBatch?.supplier_details;
    //   if (selectedBatch.supplier_details) {
    //     item_to_add.came_from = selectedBatch.supplier_details;
    // } else if (selectedBatch.batch.startsWith('C')) {
    //     item_to_add.came_from = {
    //         name: "Central Store"
    //     };
    // } else if (selectedBatch.remarks?.startsWith("Transferred from")) {
    //     let storeName = selectedBatch.remarks.replace("Transferred from", "").trim();
    //     item_to_add.came_from = {
    //         name: storeName
    //     };
    // } else {
    //     item_to_add.came_from = {
    //         name: ""
    //     };
    // }
      item_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.unit_levels = selectedItem?.unit_levels;
      item_to_add.unit_for_po = selectedItem?.unit_for_po;
      item_to_add.expiry_date = selectedBatch.expiry_date;
      item_to_add.cost_price = selectedBatch.cost_price;
      item_to_add.total_price = calculatePrice(
        selectedItem?.unit_levels,
        convertedQuantity,
        selectedBatch?.cost_price,
        selectedItem.unit_for_po);
      // item_to_add.selling_price = selectedBatch.selling_price;
      setCartItems([...cartItems, item_to_add]);
      setSelectUnitModal(false);
      setSelectedItem("");
      setSelectedBatch();
      // refSelectedItem.current.select.clearValue();
    } else {
      showNotification(props.t("Select a item batch first."), props.t("Error"));
    }
  };
  // console.log(cartItems,"CI");
  const [isDisabled, setIsDisabled] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      setIsDisabled(true)
      const object = {
        items: cartItems,
        remarks: remarks,
        return_from: storeId,
      };
      // console.log(object,"Payload");    
      let url = process.env.REACT_APP_BASEURL + "itemreturns/insert";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        setIsDisabled(false)
        showNotification(response.message, "Success");
        setSelectedItem("");
        setSelectedBatch();
        setCartItems([]);
        setRemarks("");  
        // window.location.reload()
         for (let i = 0; i < response.data?.length; i++) {
          window.open(
            `/return_order?return_id=${response.data[i]}`,
            // `/return_order?return_id=${742135}`,
            "_blank"
          );
        }
      }  else {
        setIsDisabled(false)
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false)
      showNotification(error.message, "Error");
    } finally {
      setIsDisabled(false)
    }
  };

  function handleCloseModal() {
    setSelectUnitModal(false);
    setSelectedBatch()
  }


  function handleSelectBatch(e) {
    setSelectedBatch(e)
    setSelectUnitModal(!selectUnitModal)
  }


  return (
    <React.Fragment>
            <div className="page-content">
            <Container fluid={true}>
          <Breadcrumb_2Items
            title={props.t("Orders")}
            alternateTitle={props.t("Return Items")}
            breadcrumbItem1={props.t("Return Items")}
          />
      <Row>

        <Col lg={12}>
          <Card>
            <CardBody >
              <AvForm>
                <Row className="mt-2">

                  
                    <Col lg={4} >
                      <Label>{props.t("Item")}</Label>
                      <Select
                        // ref={refSelectedItem}
                        options={allItems}
                        placeholder={props.t("None")}
                        onChange={(se) => { setSelectedItem(se) }}
                        classNamePrefix="select2-selection"
                        value={selectedItem}
                        className="basic-single"

                      />
                    </Col>
                  {/* )} */}

                  {selectedItem && (
                    <>
                      <Col lg={2}>
                        <br />
                        <Label>{`${localStorage.getItem("store_name")} Available`}</Label>
                        <br />
                        <Label>
                          {formatUnitsForReport(selectedItem?.available,selectedItem?.unit_levels)}
                        </Label>
                      </Col>
                    </>
                  )}

              {selectedItem && checkOutOfStock(selectedItem?.available || []) ? (
                  <Col lg={5}>
                    <p class="text-muted mb-2">&nbsp;</p>
                    <div class="alert alert-danger fade show text-center" role="alert">
                      {props.t("This item is out of stock.")}
                    </div>
                  </Col>
                )
                  : (
                    selectedItem && (
                        <Col lg={5}>
                          <Label>{props.t("Batch")}</Label>
                          <Select
                            ref={refSelectedBatch}
                            value={selectedBatch && selectedBatch}
                            key={selectedBatch}
                            onChange={(e) => { handleSelectBatch(e) }}
                            options={allBatches && allBatches}
                            classNamePrefix="select2-selection"
                            required
                          />
                        </Col>
                    )

                  )
                }
                <Col lg={1}></Col>
                </Row>

                

              </AvForm>
              <hr />
              {cartItems.length > 0 && (
                <Row className="mt-5">
                  <Col lg={12}>


                    <ToolkitProvider
                      bootstrap4
                      keyField="item_id"
                      data={cartItems}
                      columns={columns_cartitems}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                    <AvForm onValidSubmit={handleValidSubmit}>
                      <Row>
                        <Col lg={4}>
                        <AvField
                          name="remarks"
                          value={remarks}
                          onChange={(e) => {
                            setRemarks(e.target.value);
                          }}
                          validate={{
                            required: {
                              value: true, 
                              errorMessage: props.t("Remarks are required.")
                            },
                            minLength: {
                              value: 3,
                              errorMessage: props.t("Remarks must be at least 3 characters.")
                            }
                          }}
                          label={props.t("Remarks")}
                          placeholder={props.t("Enter Remarks")}
                          type="textarea"
                        />
                      </Col>
                        <Col lg={12}>
                          <hr />
                          <FormGroup className="mb-0 text-left">
                          <div>
                        <Button type="submit" color="primary" className="mr-1" disabled={isDisabled} style={{width:"100px"}}>
                          { isDisabled ? <Spinner size={"sm"}/> :props.t("Submit")}
                        </Button>
                      </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </AvForm>

                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>




      {/* Add Quantity modal  */}
      <EnterQuantityModal
            isOpen={selectUnitModal}
            toggle={handleCloseModal}
            onSubmit={handleAddUnits}
            item={selectedItem}
            checkLimitFor={"batch"}
            selectedBatch={selectedBatch}
          />
          </Container>
          </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(BranchItemsReturn))
);

